<template>
    <section id="upload-receipt-guidelines-drawer" :class="{ 'for-desktop': isModal }">
        <div class="guidelines-scroll-content">
            <h5 class="text-center">{{ content.heading }}</h5>
            <ul class="upload-receipt-guidelines" v-if="isShowUploadReceipt && !isOcrCustomized" >
                <li v-for="(guideline, index) in content.guidelines" :key="`upload-receipt-guideline-${index}`">
                    {{ guideline }}
                </li>
            </ul>
            <template v-if="isShowUploadReceipt && isOcrCustomized">
                <div v-for="(guidelines, title) in content.customized_guidelines" :key="title">
                    <p class="guideline-title">{{ title }}</p>
                    <ul class="upload-receipt-guidelines">
                        <li v-for="(guideline, index) in guidelines" :key="`customized-upload-receipt-guideline-${index}`">
                            {{ guideline }}
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <b-button block pill id="button-upload-receipt-guideline-got-it" @click="closeDrawer"
            :class="{ 'for-desktop mx-auto': isModal }">{{ content.button }}</b-button>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "UploadReceiptGuidelinesDrawer",
    props: {
        isModal: {
            type: Boolean,
            default: () => false
        },
        modalId: {
            type: String,
            default: () => null
        }
    },
    computed: {  
        ...mapGetters({
            isShowUploadReceipt: "merchant/isShowUploadReceipt",
            isOcrCustomized: "merchant/isOcrCustomized"
        }),
    },
    data() {
        return {
            content: {
                heading: "Receipt Upload Guidelines",
                guidelines: [
                    "Each receipt must contain at least one NutriAsia product to qualify.",
                    "Place the receipt on a flat surface before taking a photo",
                    "Keep each file under 2mb",
                    "Make sure all details are clear and easy to read"
                ],
                customized_guidelines: {
                    "Points Earning": [
                        "Each valid receipt earns 1 point"
                    ],
                    "Eligibility": [
                        "Receipt must be from an eligible store, such as Supermarkets, Hypermarkets, Convenience stores, Warehouse clubs (e.g., Landers, S&R), or E-commerce stores (e.g., Lazada, Shopee)",
                        "Valid only within 7 days of the purchase date"
                    ],
                    "Photo Quality": [
                        "Place the receipt on a flat surface before taking a photo",
                        "Keep each file under 2mb",
                        "Make sure all details are clear and easy to read"
                    ]
                },
                button: "Got it"
            }
        }
    },
    methods: {
        closeDrawer() {
            if (!this.isModal)
                this.$emit('closeDrawer');
            else
                this.$root.$emit("bv::hide::modal", this.modalId);
        }
    }
}
</script>

<style lang="scss" scoped>
#upload-receipt-guidelines-drawer {
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    padding: 48px 28px 31px;

    .guidelines-scroll-content {
        overflow-y: auto;
        flex: 1;
    }

    h5 {
        color: #2F3941;
        font-family: 'SKModernistBold', sans-serif;
        font-size: 1.375rem;
        margin-bottom: 24px;
    }

    .guideline-title {
        color: #2F3941;
        font-family: 'SKModernistBold', sans-serif;
        font-size: 16px;
        margin-bottom: 8px;
    }

    ul.upload-receipt-guidelines {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
            color: #68737D;
            font-size: 1rem;
            display: flex;
            margin-bottom: 15px;

            &::before {
                content: "";
                width: 24px;
                height: 24px;
                flex-shrink: 0;
                background: url('~@/assets/images/check.svg') no-repeat;
                background-size: contain;
                display: inline-block;
                margin-right: 10px;
            }
        }
    }

    #button-upload-receipt-guideline-got-it {
        background: var(--main-color);
        border: 0;
        font-family: 'SKModernistBold', sans-serif;
        font-size: 1rem;
        height: 50px;
        margin-top: 24px;
        flex-shrink: 0;

        &.for-desktop {
            width: 184px;
            height: 44px;
        }
    }

    &.for-desktop {
        h5 {
            font-size: 1.25rem;
        }
    }
}
</style>
